<!-- SLG Comment: Properly aligned text and link -->
<aside
  class="tw-mb-4 tw-box-border tw-border tw-border-solid tw-rounded-lg tw-bg-background tw-ps-4 tw-pe-4 tw-py-3 tw-leading-5"
  [ngClass]="[calloutClass()]"
  [attr.aria-labelledby]="titleId"
>
  @let title = titleComputed();
  @let icon = iconComputed();

  <div class="tw-flex tw-flex-col tw-gap-0.5">
    @if (title) {
      <header
        id="{{ titleId }}"
        class="tw-text-base tw-font-medium tw-flex tw-items-baseline tw-gap-1"
      >
        @if (icon) {
          <i class="bwi" [ngClass]="iconComputed()" aria-hidden="true"></i>
        }
        {{ title }}
      </header>
    }
    <div bitTypography="body2">
      <ng-content></ng-content>
    </div>
  </div>
</aside>
